/**
 * @generated SignedSource<<d4ed255fb53bfd3b54bb58216726c90b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SaveResetViewSettingsButtonUI$data = {
  readonly savedViewId?: string | null | undefined;
  readonly viewSettings?: {
    readonly canPublishViewConfig: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SaveResetViewSettingsButtonUI";
};
export type SaveResetViewSettingsButtonUI$key = {
  readonly " $data"?: SaveResetViewSettingsButtonUI$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonUI">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "savedViewId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "SaveResetViewSettingsButtonUI",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "groupBy",
              "variableName": "groupBy"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canPublishViewConfig"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "JiraDetailedView"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "JiraGroupedListView"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "JiraListView"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};
})();

(node as any).hash = "722b5d155dc65f50400bc71b9539eac7";

export default node;
